import * as Yup from 'yup';
interface SchoolConfig {
  studentDetails?: Record<string, string>;
  personalDetails?: Record<string, string>;
  currentCourseInfo?: Record<string, string>;
  officialDetails?: Record<string, string>;
  customFieldsMap?: Record<string, string>;
  motherDetails?: Record<string, string>;
  fatherDetails?: Record<string, string>;
}

const SCHOOL_VALIDATION_CONFIG: Record<string, SchoolConfig> = {
  BPIS: {
    studentDetails: {
      name: 'Name is required',
      gender: 'Gender is required',
      email: 'Email is required'
    },
    personalDetails: {
      dateOfBirth: 'Date of Birth is required'
    },
    motherDetails: {
      name: 'Mother Full Name is required',
      'personalDetails.contactNo': 'Mother Mobile No is required',
      email: 'Mother Email is required'
    },
    fatherDetails: {
      name: 'Father Full Name is required',
      'personalDetails.contactNo': 'Father Mobile No is required',
      email: 'Father Email is required'
    }
  }
};

export const getStudentProfileValidationSchema = (
  school: string | undefined,
  selectedTab: string,
  familyActiveTab: string,
  studentActiveTab: string
) => {
  const config = school ? SCHOOL_VALIDATION_CONFIG[school] || {} : {};

  const applyRequired = (section: keyof SchoolConfig, field: string) => {
    let shouldValidate = false;

    if (selectedTab === 'student_information') {
      if (studentActiveTab === 'studentProfile') {
        if (section === 'studentDetails') shouldValidate = true;
      } else if (studentActiveTab === 'studentDemographicInfo') {
        if (section === 'personalDetails' || section === 'customFieldsMap') {
          shouldValidate = true;
        }
      } else if (studentActiveTab === 'studentAcademicInfo') {
        if (section === 'currentCourseInfo') shouldValidate = true;
      } else if (studentActiveTab === 'studentHealthInfo') {
        if (section === 'officialDetails') shouldValidate = true;
      }
    } else if (selectedTab === 'family_information') {
      if (section === 'motherDetails' && familyActiveTab === 'motherDetails') {
        shouldValidate = true;
      }
      if (section === 'fatherDetails' && familyActiveTab === 'fatherDetails') {
        shouldValidate = true;
      }
      if (
        section === 'studentDetails' &&
        familyActiveTab === 'guardianDetails'
      ) {
        shouldValidate = true;
      }
    }

    const errorMessage = config[section]?.[field];
    return shouldValidate && errorMessage
      ? Yup.string().nullable().required(errorMessage)
      : Yup.string().nullable();
  };

  return Yup.object().shape({
    studentDetails: Yup.object().shape({
      name: applyRequired('studentDetails', 'name'),
      gender: applyRequired('studentDetails', 'gender'),
      email: applyRequired('studentDetails', 'email'),

      customFieldsMap: Yup.object().shape({
        field3: applyRequired('customFieldsMap', 'field3'),
        field1: applyRequired('customFieldsMap', 'field1'),
        field4: applyRequired('customFieldsMap', 'field4')
      }),

      personalDetails: Yup.object().shape({
        dateOfBirth: applyRequired('personalDetails', 'dateOfBirth'),
        birthCountry: applyRequired('personalDetails', 'birthCountry')
      })
    }),

    motherDetails: Yup.object().shape({
      name: applyRequired('motherDetails', 'name'),
      email: applyRequired('motherDetails', 'email'),
      personalDetails: Yup.object().shape({
        contactNo: applyRequired('motherDetails', 'personalDetails.contactNo')
      })
    }),

    fatherDetails: Yup.object().shape({
      name: applyRequired('fatherDetails', 'name'),
      email: applyRequired('fatherDetails', 'email'),
      personalDetails: Yup.object().shape({
        contactNo: applyRequired('fatherDetails', 'personalDetails.contactNo')
      })
    })
  });
};
